// @flow

import type { Ease } from './easings.js';

type Params = {|
  duration: number,
  from: number,
  to: number,
  ease: Ease,
  onStep: (x: number, t: number) => void,
  onEnd?: () => void,
|};

export const animate = ({
  duration,
  from,
  to,
  ease,
  onStep,
  onEnd,
}: Params): (() => void) => {
  const dtStart = new Date().getTime();
  const easingFn = ease;

  let frameId;

  const runner = () => {
    const t = Math.min((new Date().getTime() - dtStart) / duration, 1);
    const x = easingFn(t, from, to);

    onStep(x, t);

    if (t < 1) {
      frameId = window.requestAnimationFrame(runner);
    } else {
      frameId = null;
      if (onEnd) {
        onEnd();
      }
    }
  };

  frameId = window.requestAnimationFrame(runner);

  return () => {
    window.cancelAnimationFrame(frameId);
  };
};
